import { render, staticRenderFns } from "./LeaguePageGames.vue?vue&type=template&id=f5314b58&scoped=true&"
import script from "./LeaguePageGames.vue?vue&type=script&lang=js&"
export * from "./LeaguePageGames.vue?vue&type=script&lang=js&"
import style0 from "./LeaguePageGames.vue?vue&type=style&index=0&id=f5314b58&scoped=true&lang=css&"
import style1 from "./LeaguePageGames.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5314b58",
  null
  
)

export default component.exports